export default __webpack_public_path__ + "static/media/9 TELEPHONE EQUIPMENT.62e35e63.png";